import union from 'lodash/union'

import {
  LOCATION_AREAS_SUCCESS
} from '../actions/areas'

import {
  WORK_TRACKERS_SUCCESS
} from '../actions/work-trackers'

import {
  CONTRACTS_SUCCESS
} from '../actions/contracts'

import {
  LOCATION_SERVICING_LABELS_SUCCESS
} from '../actions/servicing-labels'

import {
  TECHNICIAN_WORK_SUMMARIES_SUCCESS,
} from '../actions/technician-work-summaries'

import {
  TECHNICIAN_SERVICING_VERSIONS_SUCCESS
} from '../actions/technician-servicing-versions'

export default function (state = {}, action) {
  switch (action.type) {
    case LOCATION_AREAS_SUCCESS:
      return {
        ...state,
        [action.payload.locationId]: {
          ...state[action.payload.locationId],
          areas: union(state[action.payload.locationId].areas || [], action.payload.result),
          finishedLoadingAreas: true,
        }
      }

    case CONTRACTS_SUCCESS:
      return {
        ...state,
        [action.payload.locationId]: {
          ...state[action.payload.locationId],
          contracts: action.payload.result,
          finishedLoadingContracts: true,
        }
      }

    case WORK_TRACKERS_SUCCESS:
      return {
        ...state,
        [action.payload.locationId]: {
          ...state[action.payload.locationId],
          workTrackers: action.payload.result,
          finishedLoadingWorkTrackers: true,
        }
      }

    case LOCATION_SERVICING_LABELS_SUCCESS:
      return {
        ...state,
        [action.payload.locationId]: {
          ...state[action.payload.locationId],
          servicingLabels: action.payload.result,
          finishedLoadingServicingLabels: true,
        }
      }

    case TECHNICIAN_WORK_SUMMARIES_SUCCESS: {
      return {
        ...state,
        [action.payload.locationId]: {
          ...state[action.payload.locationId],
          technicianWorkSummaries: action.payload.result,
          finishedLoadingTechnicianWorkSummaries: true,
        },
      }
    }

    case TECHNICIAN_SERVICING_VERSIONS_SUCCESS: {
      return {
        ...state,
        [action.payload.locationId]: {
          ...state[action.payload.locationId],
          technicianServicingVersions: action.payload.result,
          finishedLoadingTechnicianServicingVersions: true,
        },
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/locations.js